//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../../../axios/axios.js'

export default {
  components: {
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    labels: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  watch: {
    id: {
      handler: function () {
        this.labels.forEach(label => {
          this.$set(label, 'add', !!label.files.find(f => f.id === this.id))
        })
      },
      immediate: true
    }
  },
  methods: {
    setDocumentLabel: function (label, rewrite = false) {
      this.loading = true
      const bodyFormData = new FormData()

      const action = label.add ? 'add' : 'remove'
      bodyFormData.set('id', this.id)
      bodyFormData.set('label', label.key)
      bodyFormData.set('action', action)
      bodyFormData.set('unique', label.unique)
      bodyFormData.set('rewrite', rewrite)

      return axiosPost({
        url: '/service/delta/document/setDocumentLabel',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное изменение опции',
            progress: true,
            timeout: 3000
          })

          this.updateLabelFiles(label)

          return response.data
        },
        onFailure: (response) => {
          if (label.unique && response.currentDocuments && response.currentDocuments.length) {
            this.$d_ask({
              callback: (data, action) => {
                if (action === 'yes') {
                  this.setDocumentLabel(label, true)
                } else if (action === 'cancel2') {
                  label.add = !label.add
                }
              },
              header: 'Заменить файл?',
              warning: `У файла «${response.currentDocuments.map(doc => doc.name).join(', ')}» установлена данная опция. Только один файл может иметь данную опцию.`,
              buttons: {
                yes: 'Да',
                cancel2: 'Отмена'
              }

            })
          } else {
            label.add = !label.add

            this.$q.notify({
              type: 'negative',
              message: response.message || 'Ошибка изменения опции',
              progress: true,
              timeout: 8000
            })
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    updateLabelFiles: function (label) {
      this.loading = true

      return axiosGet({
        url: '/service/delta/document/getDocumentsByLabel?label=' + label.key,
        onSuccess: (response) => {
          label.files = response.data.documents
        },
        onFailure: 'Ошибка загрузки документа по опции'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
